import { useNavigate, useLocation } from "react-router-dom";
import "./Headerbc.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

import LightPopup from '../popuplessons/LightPopup';
import CoinLessonPopup from '../popuplessons/CoinLessonPopup';
import { useDarkMode } from '../DarkModeContext';
import profilPng from '../imagesHome/profile.png';
import profilPngWhite from '../imagesHome/profile_white.png';
import cursuriPng from '../imagesHome/cursuri.png';
import cursuriPngWhite from '../imagesHome/cursuri_white.png';
import gamesPng from '../imagesHome/games.png';
import gamesPngWhite from '../imagesHome/games_white.png';









export default function Headerbc({ coins = 0, keys = 2, energy = 0 }) {
  const { darkMode } = useDarkMode();
  const navigate = useNavigate();
  const location = useLocation();

  // 🔍 Detectăm dacă suntem într-un joc (URL conține "game")
  const isGamePage = location.pathname.toLowerCase().includes("game");

  const handleContextNavigation = () => {
    if (isGamePage) {
      navigate("/Showgames");
    } else {
      navigate("/cursuri");
    }
  };

  return (
    <div className="headerbc">
      <div className="headerbc__container">

        {/* 👈 Săgeata înapoi */}
        <button className="headerbc__arrow" onClick={() => navigate("/userpage")} aria-label="Meniu">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {/* Stânga: logo, Acasa, Cursuri/Jocuri */}
        <div className="headerbc__left">
          <div className="headerbc__logo" onClick={() => navigate("/userpage")}>
            <img src="/static/media/logo.6813a446cccb806fd043.png" alt="ContaLearn" />
          </div>

          <button className="headerbc__back-selected" onClick={() => navigate("/userpage") } aria-label="Dashboard">
            <div className="iconplustextl-log">
              <img src={darkMode ? profilPngWhite : profilPng} alt="Acasa" className="icon-lesson" />
              <div className="nav-label">Profil</div>
            </div>
          </button>

          {/* 🔁 Cursuri sau Jocuri — dinamic */}
          <button className="headerbc__back-selected" onClick={handleContextNavigation} aria-label="Context">
            <div className="iconplustextl-log">
              <img
                src={isGamePage ? (darkMode ? gamesPngWhite : gamesPng) : (darkMode ? cursuriPngWhite : cursuriPng)}
                alt={isGamePage ? "Jocuri" : "Cursuri"}
                className="icon-lesson"
              />
              <div className="nav-label">{isGamePage ? "Jocuri" : "Cursuri"}</div>
            </div>
          </button>
        </div>

        {/* Dreapta: Premium și popup-urile */}
        <div className="headerbc__icons">
          <button className="btn-premium" onClick={() => navigate("/viewplans")}>
            Premium
          </button>

          <CoinLessonPopup />
         
          <LightPopup />
        </div>

      </div>
    </div>
  );
}
